var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasLogo3HorizontalBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 250",
    style: {
      enableBackground: "new 0 0 500 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#76AADB"
    },
    d: "M144.26,19.57c0,71.85,0,143.69,0,215.54c4.81-0.01,33.97-0.56,54.18-23.11 c3.19-3.56,15.89-18.13,17.53-39.44c0.29-3.78,0.17-6.95,0-9.16c24.04-0.13,48.07-0.27,72.11-0.4c5.04,0.1,29.22,0.06,49.4-18.73 c22.45-20.89,22.39-48.61,22.31-52.99c-0.13-23.9-0.27-47.81-0.4-71.71c0.2-3.99,1.15-33.33-22.31-54.58 c-20.11-18.22-44.09-17.73-49-17.53c-24.04-0.13-48.07-0.27-72.11-0.4c-4.52,0-32.59,0.47-53.39,23.51 C144.49-9.39,144.19,14.13,144.26,19.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#FFFFFF"
    },
    d: "M215.58,18.77c0,24.17,0,48.34,0,72.51c14.87,0,29.75,0,44.62,0 c3.17,0,13.89-0.41,22.31-8.37c1.72-1.62,5.35-5.13,7.17-10.76c1.44-4.44,0.3-5.73,0.4-16.33c0.1-9.94,1.12-11.01,0-15.54 c-0.23-0.94-1.67-6.5-6.01-11.52c-8.79-10.18-22.46-10.05-24.67-9.99C244.79,18.77,230.19,18.77,215.58,18.77z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.35,
    y: 96.92,
    style: {
      fill: "#5E89B2"
    },
    width: 21.78,
    height: 32.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M10.14,79.47l-10.1,4.49v7.21l10.1-4.49l30.18,4.49v-7.21L10.14,79.47z M118.51,74.9 c-2.84-7.38-6.89-13.61-12.15-18.66c-5.26-5.05-11.63-8.91-19.1-11.56c-7.48-2.64-15.78-3.97-24.92-3.97H38.16 c-18.23,0-38.12,17.14-38.12,38.29v0.72l10.1-4.49l30.18,4.49h18.9c7.34,0,13.05,1.9,17.13,5.69c4.08,3.79,6.13,9.32,6.13,16.59 v0.48c0,6.78-2.05,12.15-6.13,16.1c-4.08,3.96-9.73,5.93-16.93,5.93h-19.1V95.42l-30.18-4.49l-10.1,4.49v113.84h0.02 c0.07,0,0.32,0,0.32,0c1.28-0.01,2.54-0.09,3.78-0.24c0.17-0.02,0.36-0.04,0.55-0.07c0.78-0.1,1.55-0.23,2.3-0.38 c0.1-0.01,0.2-0.03,0.3-0.06c0.16-0.03,0.31-0.07,0.45-0.11c0.46-0.1,0.91-0.21,1.36-0.33c0.14-0.03,0.29-0.08,0.43-0.12 c0.05-0.01,0.1-0.02,0.16-0.04c0.15-0.04,0.29-0.08,0.44-0.12c6.74-2.02,12.81-6.02,17.69-11.42c0.24-0.26,0.48-0.53,0.71-0.8 c0.14-0.17,0.28-0.34,0.42-0.51c0.04-0.05,0.08-0.1,0.12-0.14c0.42-0.51,0.83-1.02,1.23-1.55c0.09-0.12,0.18-0.24,0.27-0.36 c2.91-3.93,5.28-8.41,6.95-13.32c0.06-0.16,0.11-0.33,0.16-0.5c0.07-0.22,0.14-0.44,0.21-0.65c1.57-4.98,2.42-10.36,2.42-15.97 v-1.45h19.94c8.99,0,17.34-1.28,25.02-3.85c7.68-2.57,14.29-6.42,19.83-11.56c5.54-5.14,9.87-11.48,12.98-19.03 c3.11-7.54,4.68-16.29,4.68-26.24v-0.48C122.77,90.64,121.35,82.29,118.51,74.9z M14.35,96.92l21.78,3.24V112l-21.78-3.24V96.92 z M14.35,114.54l21.78,3.24v11.85l-21.78-3.24V114.54z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E89B2"
    },
    d: "M10.14,90.94l-10.1,4.49v113.84c0,0,4.2,0.22,10.1-1.48V90.94z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 10.14,
    y1: 79.6,
    x2: 10.14,
    y2: 86.69
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 10.14,
    y1: 79.6,
    x2: 10.14,
    y2: 86.69
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E89B2"
    },
    points: "10.15,86.69 0.04,91.18 0.04,83.96 10.14,79.47  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M28.26,73.08"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M10.15,73.08"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.3277,
    y1: 142.8055,
    x2: 54.9376,
    y2: 142.8055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M54.94,161.1H40.33c0-4.55,0-9.09,0-13.64c0-7.65,0-15.31,0-22.96c4.87,0,9.74,0,14.61,0 V161.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111170224141865039560000008681045475192844723_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.3277,
    y1: 149.728,
    x2: 40.3277,
    y2: 149.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111170224141865039560000008681045475192844723_)"
    },
    d: "M40.33,149.73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026879893811869044610000012988463776629108385_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5723,
    y1: 189.4924,
    x2: 21.9567,
    y2: 174.0824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    style: {
      stopColor: "#6B99C5",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    style: {
      stopColor: "#6F9FCC",
      stopOpacity: 0.3369
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026879893811869044610000012988463776629108385_)"
    },
    d: "M0.02,185.84 C0.02,185.84-0.02,185.85,0.02,185.84c18.95,0.24,40.31-19.08,40.31-50.24l0,0v25.5l0,0c0.3,30.83-21.34,48.4-40.29,48.16 c-0.04,0,0.33,0,0.33,0L0.02,185.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056405521119789885070000009736057659958051208_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.7533,
    y1: 176.7926,
    x2: 486.6458,
    y2: 179.6308,
    gradientTransform: "matrix(-0.8951 -0.4458 0.4458 -0.8951 376.4226 563.5543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6162,
    style: {
      stopColor: "#6F9FCC",
      stopOpacity: 0.3838
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056405521119789885070000009736057659958051208_)"
    },
    d: "M40.32,161.1 c0,31.15-21.34,48.4-40.29,48.16c-0.04,0,0,0,0,0C7.69,200.09,32.99,169.83,40.32,161.1L40.32,161.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M177.01,169.76h68.33c0,21.82-16.24,39.52-36.27,39.52h-71.58c0-0.13,0.01-0.26,0.01-0.38 c0,0-0.01,0-0.01,0V76.98c0-20.03,17.69-36.27,39.52-36.27V169.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M379.39,208.13c-19.99,4.88-39.82-6.04-44.3-24.39l-1.94-7.96l-0.83-3.97h-34.87l-0.83,3.97 l-1.94,7.96c-4.48,18.35-24.31,29.27-44.3,24.39l35.82-144.02c2.19-8.98,7.15-15.24,14.91-19.68c4.15-2.37,8.77-3.7,13.77-3.7 c5,0,9.63,1.34,13.77,3.7c7.76,4.44,12.72,10.7,14.91,19.68L379.39,208.13z M326.1,141.89l-11.21-53.86l-11.21,53.86H326.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M500,156.88v1.4c0,28.12-22.88,51-51,51h-57.67c0-21.7,16.15-38.36,36.08-38.36H449 c6.85,0,12.64-5.79,12.64-12.64v-1.4c0-6.85-5.79-12.64-12.64-12.64h-12.14c-16.69,0-31.54-8.06-40.85-20.5l0,0 c-6.37-8.51-10.15-19.07-10.15-30.5v-1.4c0-28.12,22.88-50.99,51-50.99h53.33c0,21.7-16.15,38.36-36.08,38.36h-17.26 c-6.85,0-12.64,5.79-12.64,12.64v1.4c0,6.85,5.79,12.64,12.64,12.64H449c16.69,0,31.54,8.06,40.85,20.5 C496.22,134.89,500,145.45,500,156.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102518569320512004450000007671000729473022125_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.1011,
    y1: 158.604,
    x2: 315.711,
    y2: 158.604,
    gradientTransform: "matrix(0.9824 0.1866 -0.1553 0.8174 29.5015 -30.0413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102518569320512004450000007671000729473022125_)"
    },
    d: "M312.52,171.81l-14.87,0 c0.71-3.72,1.41-7.43,2.12-11.15c1.19-6.26,2.73-12.51,3.92-18.77h11.21L312.52,171.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109722967598524174890000001242555391428820373_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.9334,
    y1: 126.5532,
    x2: 459.0988,
    y2: 126.5532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109722967598524174890000001242555391428820373_)"
    },
    d: "M457.06,147.23 c-1.92-1.58-4.77-3.04-8.06-2.99l-6.07,0c0,0,0-9.52,0-14.31c0-8.07,0-15.99,0-24.05l6.07,0c4.04,0.04,6.36,0.3,10.1,1.01 L457.06,147.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160162915176185836450000011745739561869396123_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.0059,
    y1: 189.5174,
    x2: 191.6159,
    y2: 189.5174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160162915176185836450000011745739561869396123_)"
    },
    d: "M191.62,209.27h-14.61 c0-4.91,0-9.82,0-14.72c0-8.26,0-16.53,0-24.79c4.87,0,9.74,0,14.61,0V209.27z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasLogo3HorizontalBig);
export default __webpack_public_path__ + "static/media/Plas-logo-3-horizontal-big.1fa3a10d8132712029eb9112ee54f931.svg";
export { ForwardRef as ReactComponent };